import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import client from './client';
import type { ThresholdsDto } from '../types/api';

export const thresholdKeys = {
  current: () => ['thresholds'] as const,
};

export function useThresholds() {
  return useQuery({
    queryKey: thresholdKeys.current(),
    queryFn: () => client.get<ThresholdsDto>('/thresholds').then((r) => r.data),
  });
}

export function useUpdateThresholds() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Partial<ThresholdsDto>) =>
      client.patch<ThresholdsDto>('/thresholds', body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: thresholdKeys.current() }),
  });
}
